import { MuvicardService } from '../../../../services/muvicard.service'

export async function getMuvicardInstallmentOptions(value) {
	let options = []
	if (value === 0) return options

	let response = await MuvicardService.GetInstallmentsOptions(value)
	const array = response.data

	if (array.length > 0) {
		array.forEach((element) => {
			let interest = element.installments * element.installmentValue - value
			let installmentValue = element.installmentValue.$toReais()
			options.push({
				value: element.installments,
				label: `${element.installments}x de
						${installmentValue} ${
					element.withInterest
						? '(Juros: ' + interest.$toReais() + ')'
						: ' sem juros'
				}
						 `,
				interest,
			})
		})
	}
	return options
}
